import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import styled from 'styled-components';
import telefonIcon from '../icons/Telefon.png';
import mailIcon from '../icons/Post.png';

export default class Contact extends Component {

    render() {
        return (
            <JSection id='Contact'>
                <JHeader>
                    <h1>Nehmen Sie Kontakt auf</h1>
                </JHeader>
                <JRow>
                    <JCol>
                        <JLink href='tel:+496722500200'><img src={telefonIcon} width={60} alt='' />  <br />+49 (0) 6722 500-0 </JLink>
                    </JCol>
                    <JCol>
                        <JLink href='mailto:info@m-l-g.de'><img src={mailIcon} width={60} alt='' /> <br /> info@m-l-g.de</JLink>
                    </JCol>
                </JRow>
                <JMap>
                    <iframe id='gmap' title='s' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20524.68591563538!2d7.911931911658553!3d49.98162693744258!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bdef3bae0beb35%3A0xb0fb359c8760874a!2sKaiserstra%C3%9Fe+6A%2C+65385+R%C3%BCdesheim+am+Rhein!5e0!3m2!1sde!2sde!4v1557348907212!5m2!1sde!2sde" width="100%" height="450" frameBorder="0" ></iframe>
                </JMap>
            </JSection>
        );
    }
}

const JCol = styled(Col)`
    padding: 3rem;
`;

const JLink = styled.a`
    color: #000;
    :hover{
        color: #000;
        text-decoration: none;
    }
`;

const JSection = styled(Container)`
    padding-top: 3rem;
    padding-bottom: 3rem;
`;

const JRow = styled(Row)`
    text-align: center;
    display: flex;
    justify-content: center;
    padding-bottom: 2rem;
`;

const JMap = styled.div`
    width: 100%;
    padding-bottom: 5rem;
`;

const JHeader = styled.div`
    margin-top: 3rem;
    text-align: center;
`;